import React, { Component } from "react";

class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>
                Reset Password
            </div>
        );
    }
}

export default ForgetPassword;
